import TimezonePicker from "react-timezone";
import React from "react";
import {Box} from "@mui/system";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function TimezonePickerComponent(props) {
    const { placeHolder, label, input, ...rest } = props;

    return(
        <Box sx={{position: 'relative', display: 'flex'}}>
            <TimezonePicker
                {...rest}
                {...input}
                placeholder={placeHolder}
                name={input.name}
                onChange={input.onChange}
                className="profile-timezone"
                required
            />
            <ArrowDropDownIcon sx={{position: 'absolute', right: '15px', top: '25%', width: '30px'}}/>
        </Box>
    )
}